import { AppState } from 'domain/reducers';
import api from 'libs/api';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { globalAlertsActions, globalAlertsDismissAction } from './actions';
import { globalAlertsIsLoadingSelector } from './selectors';

// Runs in background without blocking UI; no global loading state and errors are swallowed.
export const thunkFetchGlobalAlerts =
  (): ThunkAction<void, AppState, null, Action<string>> => async (dispatch, getState) => {
    const state = getState();
    const isGlobalAlertsLoading = globalAlertsIsLoadingSelector(state);
    if (isGlobalAlertsLoading) {
      return;
    }
    try {
      dispatch(globalAlertsActions.request());
      const response = await api.globalAlerts.getAll();
      dispatch(globalAlertsActions.success({ alerts: response.data.resources }));
    } catch (e) {
      dispatch(globalAlertsActions.failure(e as Error));
    }
  };

// Optimistic: hide now, fire-and-forget; the server keeps it hidden next load.
export const thunkDismissGlobalAlert =
  (id: number): ThunkAction<void, AppState, null, Action<string>> =>
  (dispatch) => {
    dispatch(globalAlertsDismissAction({ id }));
    api.globalAlerts.dismiss({ id }).catch(() => undefined);
  };

export const thunkClickGlobalAlert =
  (id: number): ThunkAction<void, AppState, null, Action<string>> =>
  () => {
    api.globalAlerts.click({ id }).catch(() => undefined);
  };
